import * as models from '../../shared/model/api/models';
import { ViewConstants } from '../../constants';

export class AuthorizationRouteConfiguration {
    static readonly USER_RTI_RETAIL_DELETE_FEATURE_ROLE: string[] = [
        "405102", "138429", "145903"
    ];
    static readonly ROUTEPATH_FEATURE_MAPPING: models.RoutePathDealerFeatureMap[] = [
        {
            routePath: ViewConstants.ROUTE_VEHICLE,
            dealerFeatureName: ViewConstants.FEATURE_VEHICLE
        },
        {
            routePath: ViewConstants.ROUTE_PRICINGPROMOTE,
            dealerFeatureName: ViewConstants.FEATURE_PRICINGPROMOTE
        },
        {
            routePath: ViewConstants.ROUTE_CUSTOMERDEALSUMMARY,
            dealerFeatureName: ViewConstants.FEATURE_CUSTOMERDEALSUMMARY
        },
        {
            routePath: ViewConstants.ROUTE_CUSTOMERDEALDETAIL,
            dealerFeatureName: ViewConstants.FEATURE_CUSTOMERDEALDETAIL
        },
        {
            routePath: ViewConstants.ROUTE_CUSTOMERDEALALERT,
            dealerFeatureName: ViewConstants.FEATURE_CUSTOMERDEALDETAIL
        },
        {
            routePath: ViewConstants.ROUTE_CUSTOMERLEADDETAIL,
            dealerFeatureName: ViewConstants.FEATURE_CUSTOMERLEADDETAIL
        },
        {
            routePath: ViewConstants.ROUTE_CUSTOMERACTIVITYDETAIL,
            dealerFeatureName: ViewConstants.FEATURE_CUSTOMERACTIVITYDETAIL
        },
        {
            routePath: ViewConstants.ROUTE_DEALNOTIFICATION,
            dealerFeatureName: ViewConstants.FEATURE_DEALNOTIFICATION
        },
        {
            routePath: ViewConstants.ROUTE_VEHICLEHOLD,
            dealerFeatureName: ViewConstants.FEATURE_VEHICLEHOLD
        },
        {
            routePath: ViewConstants.ROUTE_FEATURE_WRITEUPSLEADS,
            dealerFeatureName: ViewConstants.FEATURE_WRITEUPSLEADS
        },
        {
            routePath: ViewConstants.ROUTE_FEATURE_CUSTOMERSUMMARY,
            dealerFeatureName: ViewConstants.FEATURE_CUSTOMERSUMMARY
        },
        {
            routePath: ViewConstants.ROUTE_CUSTOMERSUMMARY,
            dealerFeatureName: ViewConstants.FEATURE_CUSTOMERDEALSUMMARY
        },
        
        {
            routePath: ViewConstants.ROUTE_FEATURE_WRITEUPDETAILS,
            dealerFeatureName: ViewConstants.FEATURE_WRITEUPDETAILS
        },
        {
            routePath: ViewConstants.ROUTE_FEATURE_FIADMIN,
            dealerFeatureName: ViewConstants.FEATURE_FIADMIN
        },
        {
            routePath: ViewConstants.ROUTE_CUSTOMERSUMMARY,
            dealerFeatureName: ViewConstants.FEATURE_CUSTOMERSUMMARY
        },
        {
            routePath: ViewConstants.ROUTE_WRITEUPDETAILS,
            dealerFeatureName: ViewConstants.FEATURE_WRITEUPDETAILS
        },
        {
            routePath: ViewConstants.ROUTE_FIADMIN,
            dealerFeatureName: ViewConstants.FEATURE_FIADMIN
        },
        // {
        //     routePath: ViewConstants.ROUTE_FEATURE_FI_ADMIN,
        //     dealerFeatureName: ViewConstants.FEATURE_FI_ADMIN
        // },
        {
            routePath: ViewConstants.ROUTE_FEATURE_CUSTOMERVIEW,
            dealerFeatureName: ViewConstants.FEATURE_CUSTOMERVIEW
        },
        {
            routePath: ViewConstants.ROUTE_CUSTOMERVIEW,
            dealerFeatureName: ViewConstants.FEATURE_CUSTOMERVIEW
        },
    ];

    static readonly routeConfiguration: models.RouteConfiguration = <models.RouteConfiguration>{
        'Roles':
        [
            {
                'RoleName': ViewConstants.DD_NEWVEHICLEVMSEXCLUDECOST,
                'Routes': [
                    {
                        'RoutePath': ViewConstants.ROUTE_VEHICLE,
                    },
                    // {
                    //     'RoutePath': ViewConstants.ROUTE_CUSTOMERDEALSUMMARY,
                    // },
                    // {
                    //     'RoutePath': ViewConstants.ROUTE_CUSTOMERDEALDETAIL,
                    // },
                    // {
                    //     'RoutePath': ViewConstants.ROUTE_CUSTOMERDEALALERT,
                    // },
                    // {
                    //     'RoutePath': ViewConstants.ROUTE_CUSTOMERLEADDETAIL,
                    // },
                    // {
                    //     'RoutePath': ViewConstants.ROUTE_CUSTOMERACTIVITYDETAIL,
                    // },
                    // {
                    //     'RoutePath': ViewConstants.ROUTE_DEALNOTIFICATION,
                    // }
                ]
            },
            {
                'RoleName': ViewConstants.DD_NEWVEHICLEVMSINCLUDECOST,
                'Routes': [
                    {
                        'RoutePath': ViewConstants.ROUTE_VEHICLE,
                    },
                    {
                        'RoutePath': ViewConstants.ROUTE_VEHICLEHISTORY,
                    },
                    
                    // {
                    //     'RoutePath': ViewConstants.ROUTE_CUSTOMERDEALSUMMARY,
                    // },
                    // {
                    //     'RoutePath': ViewConstants.ROUTE_CUSTOMERDEALDETAIL,
                    // },
                    // {
                    //     'RoutePath': ViewConstants.ROUTE_CUSTOMERDEALALERT,
                    // },
                    // {
                    //     'RoutePath': ViewConstants.ROUTE_CUSTOMERLEADDETAIL,
                    // },
                    // {
                    //     'RoutePath': ViewConstants.ROUTE_CUSTOMERACTIVITYDETAIL,
                    // },
                    // {
                    //     'RoutePath': ViewConstants.ROUTE_DEALNOTIFICATION,
                    // },
                ]
            },
            {
                'RoleName': ViewConstants.DD_RTI_MST_CONSOLE,
                'Routes': [
                    {
                        'RoutePath': ViewConstants.ROUTE_VEHICLE,
                    },                   
                    {
                        'RoutePath': ViewConstants.ROUTE_CUSTOMERDEALSUMMARY,
                    },
                    {
                        'RoutePath': ViewConstants.ROUTE_CUSTOMERDEALDETAIL,
                    },
                    {
                        'RoutePath': ViewConstants.ROUTE_CUSTOMERDEALALERT,
                    },
                    {
                        'RoutePath': ViewConstants.ROUTE_CUSTOMERLEADDETAIL,
                    },
                    {
                        'RoutePath': ViewConstants.ROUTE_CUSTOMERACTIVITYDETAIL,
                    },
                    {
                        'RoutePath': ViewConstants.ROUTE_DEALNOTIFICATION,
                    },
                    //--- Feature Modules Route path
                    {
                        //
                        // /wl/ for writeups-leads module 
                        //
                        'RoutePath': ViewConstants.ROUTE_FEATURE_WRITEUPSLEADS,
                    },
                    { 
                        //
                        // '/cs/'
                        //
                        'RoutePath': ViewConstants.ROUTE_FEATURE_CUSTOMERSUMMARY,
                    },
                    {
                        //
                        // '/wd/'
                        //
                        'RoutePath': ViewConstants.ROUTE_FEATURE_WRITEUPDETAILS,
                    },
                    {
                        'RoutePath': ViewConstants.ROUTE_CUSTOMERSUMMARY,
                    },
                    {
                        'RoutePath': ViewConstants.ROUTE_FIADMIN,
                    },
                    {
                        'RoutePath': ViewConstants.ROUTE_WRITEUPDETAILS,
                    },
                    {
                        'RoutePath': ViewConstants.ROUTE_FEATURE_FIADMIN,
                    },
                    {
                        'RoutePath': ViewConstants.ROUTE_FEATURE_CUSTOMERVIEW,
                    },
                    {
                        'RoutePath': ViewConstants.ROUTE_CUSTOMERVIEW,
                    }
                ]
            },
            {
                'RoleName': ViewConstants.DD_RTIEXPRESSPURCHASEROLE,
                'Routes': [
                    {
                        'RoutePath': ViewConstants.ROUTE_VEHICLE,
                    },
                   
                    // {
                    //     'RoutePath': ViewConstants.ROUTE_CUSTOMERDEALSUMMARY,
                    // },
                    // {
                    //     'RoutePath': ViewConstants.ROUTE_CUSTOMERDEALDETAIL,
                    // },
                    // {
                    //     'RoutePath': ViewConstants.ROUTE_CUSTOMERDEALALERT,
                    // },
                    // {
                    //     'RoutePath': ViewConstants.ROUTE_CUSTOMERLEADDETAIL,
                    // },
                    // {
                    //     'RoutePath': ViewConstants.ROUTE_CUSTOMERACTIVITYDETAIL,
                    // },
                    // {
                    //     'RoutePath': ViewConstants.ROUTE_DEALNOTIFICATION,
                    // },
                    
                ]
            },
        ]
    };
}